import axios from "axios";
import { API_ENDPOINT } from "../../common/constants/apiConstants";

export const getScheduleInterviews = async(params={})=>{
  const url = `${API_ENDPOINT.SCHEDULE.GET_SCHEDULE_INTERVIEWS}`;
  try {
    const response = await axios.post(url,  params );
    return response.data;
  } catch (error) {
    console.error("Scheduled Interviews API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
}

export const scheduleInterview = async (payload) =>{
  const url = `${API_ENDPOINT.SCHEDULE.CREATE_SCHEDULE_INTERVIEWS}`
  try {
    const response = await axios.post(url, payload);
    return response;
  } catch (error) {
    console.error("Schedule interview API Failed:", error);
    throw error.response || { message: "Network error" };
  }
}

export const updateScheduleInterview = async (id, payload) => {
  const url = `${API_ENDPOINT.SCHEDULE.UPDATE_SCHEDULE_INTERVIEWS}/${id}`;
  try {
    const response = await axios.put(url, payload);
    return response;
  } catch (error) {
    console.error("Update schedule interview API Failed:", error);
    throw error.response || { message: "Network error" };
  }
}

export const getMetricsScheduleInterviews = async()=>{
  const url = `${API_ENDPOINT.SCHEDULE.METRICS_SCEDULE_INTERVIEWS}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Scheduled Metrics Interviews API Failed:", error);
    throw error.response?.data || { message: "Network error" };
  }
}